module.exports = __webpack_public_path__ + "static/media/arrow_icon_off.61118a2d.svg";